import { render, staticRenderFns } from "./CertificationRegulation.vue?vue&type=template&id=3515e7e2&scoped=true&"
import script from "./CertificationRegulation.vue?vue&type=script&lang=js&"
export * from "./CertificationRegulation.vue?vue&type=script&lang=js&"
import style0 from "./CertificationRegulation.vue?vue&type=style&index=0&id=3515e7e2&lang=scss&scoped=true&"
import style1 from "./CertificationRegulation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515e7e2",
  null
  
)

export default component.exports